<template>
  <div class="message-table">
    <instantwin-message-dialog ref="instantwinMessageDialog"></instantwin-message-dialog>
    <serial-code-management ref="serialCodeManagement"></serial-code-management>
    <el-table class="mb-x2" :data="data" stripe @header-click="headerClick">
      <el-table-column label="ステータス" sort-by="-status" :render-header="renderHeader" min-width="10%">
        <template slot-scope="scope">
          <message-status :status="scope.row.status"></message-status>
        </template>
      </el-table-column>
      <el-table-column label="種別" sort-by="-messageType" :render-header="renderHeader" min-width="8%">
        <template slot-scope="scope">
          <div class="label label-primary" type="primary" v-if="scope.row.messageType === 'win'">当選</div>
          <div class="label label-default" v-if="scope.row.messageType === 'lose'">落選</div>
        </template>
      </el-table-column>
      <el-table-column label="メッセージ名" sort-by="-name" :render-header="renderHeader" min-width="12%">
        <template slot-scope="scope">{{ scope.row.name }}</template>
      </el-table-column>
      <el-table-column label="配信期間" sort-by="-endDatetime" :render-header="renderHeader" min-width="15%">
        <template slot-scope="scope">
          <div v-if="!scope.row.startDatetime && !scope.row.endDatetime">-</div>
          <div v-if="scope.row.startDatetime || scope.row.endDatetime">
            {{ formatDatetime(scope.row.startDatetime) }} ~
          </div>
          <div v-if="scope.row.startDatetime || scope.row.endDatetime">{{ formatDatetime(scope.row.endDatetime) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="返信方法" sort-by="-replyType" :render-header="renderHeader" min-width="12%">
        <template slot-scope="scope">
          <div v-if="!scope.row.replyType">-</div>
          <div v-if="scope.row.replyType === 'mention'">メンション</div>
          <div v-if="scope.row.replyType === 'dm'">DM</div>
          <div v-if="scope.row.replyType === 'mention-and-dm'">メンション & DM</div>
        </template>
      </el-table-column>
      <el-table-column label="当選率" sort-by="-winningRate" :render-header="renderHeader" min-width="9%">
        <template slot-scope="scope">
          <div v-if="scope.row.winningRateChangeType === 'auto'">自動変動</div>
          <div v-else>
            <div v-if="scope.row.messageType === 'win'">{{ scope.row.winningRate + '%' }}</div>
            <div v-if="scope.row.messageType === 'lose'">-</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="重み付け値" sort-by="-weightCount" :render-header="renderHeader" min-width="11%">
        <template slot-scope="scope">
          <div>{{ formatNumber(scope.row.weightCount) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="配信数(本日)" min-width="10%">
        <template slot-scope="scope">
          <div v-if="scope.row.messageType === 'win'">
            <div>{{ formatNumber(scope.row.dailySendCount) }}</div>
            <div class="sub-value" v-if="scope.row.dailyWinnerCount !== 0">
              残り:&nbsp;{{ formatNumber(scope.row.remainDailySendCount) }}
            </div>
          </div>
          <div v-if="scope.row.messageType === 'lose'">-</div>
        </template>
      </el-table-column>
      <el-table-column label="配信数" sort-by="-sendCount" :render-header="renderHeader" min-width="10%">
        <template slot-scope="scope">
          <div>{{ formatNumber(scope.row.sendCount) }}</div>
          <div class="sub-value" v-if="scope.row.messageType === 'win'">
            残り:&nbsp;{{ formatNumber(scope.row.remainSendCount) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column min-width="15%">
        <template slot-scope="scope">
          <div layout layout-align="end">
            <el-tooltip
              :enterable="false"
              v-if="scope.row.messageType === 'win'"
              placement="top"
              content="シリアルコードの管理"
            >
              <el-button
                class="el-button--icon button-badget"
                type="default"
                @click="openSerialCodeManagement(scope.row.id, scope.row.name, true)"
                ><i class="mdi mdi-ticket"></i>
                <div class="badge badge-active" v-if="scope.row.countSerialCode > 0">
                  {{ formatNumber(scope.row.countSerialCode) }}
                </div>
              </el-button>
            </el-tooltip>
            <el-tooltip :enterable="false" placement="top" content="編集">
              <el-button
                class="el-button--icon"
                type="default"
                @click="$refs.instantwinMessageDialog.open('edit', scope.row.id, scope.row.messageType)"
                ><i class="mdi mdi-table-edit"></i
              ></el-button>
            </el-tooltip>
            <el-tooltip :enterable="false" placement="top" content="複製">
              <el-button
                class="el-button--icon"
                type="default"
                @click="$refs.instantwinMessageDialog.open('copy', scope.row.id, scope.row.messageType)"
                :disabled="isFinished || (!isSystemAdmin && !allowCreateInstantwin)"
                ><i class="mdi mdi-content-duplicate"></i
              ></el-button>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :total="options.total"
      :pagingNo="options.pagingNo"
      :limitCount="options.limitCount"
      :onChangePagingNo="onChangePagingNo"
      :onChangeLimitCount="onChangeLimitCount"
    ></pagination>
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.label {
  display: inline-block;
  padding: 0 $spacing-unit;
  color: $text-color-white;
  border-radius: 5px;

  &.label-primary {
    background-color: $primary-color;
  }

  &.label-default {
    background-color: $disabled-color;
  }
}

.sub-value {
  font-size: $font-small-size;
}

.button-badget {
  position: relative;
}

.badge {
  right: -8px;
  bottom: -1px;
  font-size: 10px;
  line-height: 16px;
}
</style>
<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import Pagination from '@/client/components/_atoms/pagination'
import { CAMPAIGN_STATUS } from '@/client/constant'
import Util from '@/client/core/util'
import InstantwinMessageDialog from '@/client/features/twitter_instantwin_message/instantwin_message_dialog'
import MessageStatus from '@/client/features/twitter_instantwin_message/message_status'
import SerialCodeManagement from '@/client/features/twitter_instantwin_message/serial_code_management'
import { formatDatetime, formatNumber } from '@/client/filters/filters'
import { useSystemStore } from '@/client/store/useSystemStore'
import { useTwitterInstantwinMessageStore } from '@/client/store/useTwitterInstantwinMessageStore'
import { useTwitterInstantwinSerialCodeStore } from '@/client/store/useTwitterInstantwinSerialCodeStore'

export default defineComponent({
  props: {
    data: Array,
    options: Object,
    onChangePagingNo: Function,
    onChangeLimitCount: Function,
    onChangeSortBy: Function
  },
  components: {
    MessageStatus,
    Pagination,
    InstantwinMessageDialog,
    SerialCodeManagement
  },

  computed: {
    ...mapState(useTwitterInstantwinMessageStore, {
      campaign: state => {
        if (state.campaign) {
          return state.campaign
        }
        return {}
      }
    }),
    ...mapState(useSystemStore, {
      isSystemAdmin: state => Boolean(state.user.isSystemAdmin),
      allowCreateInstantwin: state => Boolean(state.currentGroup.allowCreateInstantwin)
    }),

    isFinished() {
      if (this.campaign) {
        return [CAMPAIGN_STATUS.DURING_FINAL_COLLECTION, CAMPAIGN_STATUS.COLLECTION_COMPLETED].includes(
          this.campaign.status
        )
      }

      return false
    }
  },

  methods: {
    formatDatetime,
    formatNumber,

    ...mapActions(useTwitterInstantwinSerialCodeStore, ['setMessageId']),

    /**
     * Open serial code management
     * @param {number} messageId
     * @param {string} messageName
     */
    openSerialCodeManagement(messageId: number, messageName: string) {
      this.setMessageId(messageId)
      this.$refs.serialCodeManagement.open(this.campaign.id, messageName, true)
    },

    /**
     * ヘッダーをクリックするとソートする
     * @param {*} column
     */
    headerClick(column: any) {
      if (!column.sortBy) {
        return
      }
      if (column.sortBy.indexOf('-') === 0) {
        if (this.options.sortBy === column.sortBy) {
          this.onChangeSortBy(column.sortBy.substring(1))
        } else {
          this.onChangeSortBy(column.sortBy)
        }
      } else {
        if (this.options.sortBy === column.sortBy) {
          this.onChangeSortBy('-' + column.sortBy)
        } else {
          this.onChangeSortBy(column.sortBy)
        }
      }
    },

    /**
     * ヘッダー描画
     * @param {*} createElement
     * @param {*} { column }
     */
    renderHeader(createElement: any, { column }: any) {
      return Util.renderHeader(createElement, column.label, Util.getSortClass(this.options.sortBy, column.sortBy))
    }
  }
})
</script>
